<template>
  <th name="sort-column" :colspan="column.colspan" :rowspan="column.rowspan" :class="column.class + [ (parseInt(column.colspan) === 1 && sortDisp) ? ' cursor-pointer' : '' ]" :style="column.style" @click="setSortProperty(column.key, column.colspan)">
    {{ column.name }}
    <i :class="'fa fa-' + sortType" v-show="parseInt(column.colspan) === 1 && sortDisp"></i>
  </th>
</template>

<script>
export default {
  name: 'sort-column',
  computed: {
    sortType () {
      if (this.column.sortNum === 0) {
        return 'sort text-gray'
      } else if (this.column.sortNum === 1) {
        return 'sort-asc'
      } else if (this.column.sortNum === 2) {
        return 'sort-desc'
      } else {
        return 'sort text-gray'
      }
    }
  },
  methods: {
    setSortProperty (sortKey, colSpan) {
      if (parseInt(colSpan) === 1 && this.sortDisp) {
        let sortNum = this.column.sortNum + 1
        if (sortNum <= 2) {
          this.$set(this.column, 'sortNum', sortNum)
          this.$emit('resetOthersColumnSortKey', sortKey)
        } else {
          this.$set(this.column, 'sortNum', 0)
          this.$emit('resetOthersColumnSortKey', '')
        }
      }
    }
  },
  props: {
    column: {
      type: Object
    },
    sortDisp: {
      type: Boolean,
      default: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// sortColumn.vue?e96d55cc